const authData = [{
    checked: false,
    auth_title: '',
    auth_first_name: '',
    auth_middle_name: '',
    auth_last_name: '',
    auth_entity_role: ''
}];

const SET_AUTH_INFO = 'SET_AUTH_INFO';

export const setAuthInfo = (authData) => ({
    type: SET_AUTH_INFO,
    payload: authData,
});

const auth_store = (state = authData, action) => {
    switch (action.type) {
        case SET_AUTH_INFO:
            return [
                ...action.payload,
            ]
        default:
            return state;
    }
};

export default auth_store;